import React from 'react';
import styles from './HeaderView.module.scss';
import LoginUser from '../LoginUser';
import logo from '../../assets/images/logo.svg';
import LocaleSwitcher from '../LocaleSwitcher';

const HeaderView: React.FC = () => (
  <header className={styles.header}>
    <a href="/">
      <img className={styles.logo} src={logo} alt="" />
    </a>
    <div className={styles.right}>
      <LoginUser />
      <div className={styles.localeWrapper}>
        <LocaleSwitcher />
      </div>
    </div>
  </header>
);

export default HeaderView;
